import styled from "styled-components";

export const List = styled.ul`
  width: 60%;
  max-width: 500px;
  padding: 10px 15px 10px 15px;
`;